<app-empty-state *ngIf="attachmentsLength === 0" [message]="emptyMessage" [buttonLabel]="buttonLabel"
    [buttonIcon]="buttonIcon" [showUpload]="showUpload" (fileSelect)="fileSelect.emit($event)"></app-empty-state>

<div class="grid p-5" *ngIf="attachmentsLength > 0">
    <div class="col-12 text-start">
        <p class="lable flex align-items-center">
            Attachments
            <button pButton type="button" icon="icon-edit" class="p-button-text p-button-plain text-primary p-0">
            </button>
        </p>
    </div>

    <div class="col-12 mt-1">
        <div class="flex justify-content-center mt-3">
            <p-galleria [value]="images" [responsiveOptions]="responsiveOptions" [containerStyle]="{ 'max-width': '740px' }"
                [numVisible]="5" [circular]="true" [showThumbnails]="true">
                <ng-template pTemplate="item" let-item>
                    <div class="image-container">
                        <img [src]="item.itemImageSrc" 
                        alt="Image"
                        class="img"/>
                    </div>
                </ng-template>
                <ng-template pTemplate="thumbnail" let-item>
                    <div class="image-thumbnail-container">
                        <img [src]="item.thumbnailImageSrc"
                        alt="Thumbnail"
                        class="img" />
                    </div>
                </ng-template>
            </p-galleria>
        </div>
    </div>
</div>